/// <reference path="DOMAttached.js" />

class Collapser extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.collapsedIds = this.options.collapsedIds.split(' ');
		this.afterwardsIds = this.options.afterwardsIds.split(' ');
		this.link = this.el.querySelector('.collapserLink');
		this.safeObserve(this.link, 'click', this.onClick.bind(this));
	}

	onClick(ev) {
		this.afterwardsIds.forEach(function(id) {
			document.getElementById(id).style.display = 'none';
		});

		this.collapsedIds.forEach(function(id) {
			document.getElementById(id).style.display = 'block';
		});
	}
}
